import React, { useState } from "react";
import styled from "styled-components";
// import { Link as ScrollLink } from "react-scroll";
import { useNavigate } from "react-router-dom";
// Assets
import CloseIcon from "../../assets/svg/CloseIcon";
import LogoIcon from "../../assets/svg/Logo";
// Menu data
import menuData from "../../data/menuData";
import { useLocation } from "react-router-dom";

export default function Sidebar({ sidebarOpen, toggleSidebar }) {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const servicesMenu = menuData.find((item) => item.title === "Services");

  const handleServiceClick = (path) => {
    toggleSidebar(false);
    navigate(path);
  };
  const location = useLocation();

  const handleScrollOrNavigate = (id) => {
    toggleSidebar(false);
    if (location.pathname === "/") {
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100); // wait a moment
      }
    } else {
      navigate("/", { state: { scrollTo: id } });
    }
  };

  return (
    <Wrapper className="animate darkBg" sidebarOpen={sidebarOpen}>
      <SidebarHeader className="flexSpaceCenter">
        <div className="flexNullCenter">
          <LogoIcon />
          <h1 className="whiteColor font20" style={{ marginLeft: "15px" }}>
            fanatic
          </h1>
        </div>
        <CloseBtn
          onClick={() => toggleSidebar(!sidebarOpen)}
          className="animate pointer"
        >
          <CloseIcon />
        </CloseBtn>
      </SidebarHeader>

      <UlStyle className="flexNullCenter flexColumn">
        <li
          className="semiBold font15 pointer whiteColor"
          onClick={() => handleScrollOrNavigate("home")}
        >
          Home
        </li>

        {/* Services with Dropdown */}
        <li
          className="semiBold font15 pointer whiteColor"
          style={{ padding: "10px 15px" }}
          onClick={() => setShowDropdown(!showDropdown)}
        >
          Services
        </li>
        {showDropdown && (
          <DropdownScrollArea>
            {servicesMenu?.submenu?.map((sub) => (
              <li
                key={sub.id}
                className="semiBold font14 pointer whiteColor"
                style={{ padding: "8px 20px", cursor: "pointer" }}
                onClick={() => handleServiceClick(sub.path)}
              >
                {sub.title}
              </li>
            ))}
          </DropdownScrollArea>
        )}

        {/* <li
          className="semiBold font15 pointer whiteColor"
          onClick={() => handleScrollOrNavigate("projects")}
        >
          Projects
        </li> */}
        {/* <li className="semiBold font15 pointer">
          <ScrollLink
            onClick={() => toggleSidebar(false)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="blog"
            spy={true}
            smooth={true}
            offset={-60}
          >
            Blog
          </ScrollLink>
        </li> */}
        <li
          className="semiBold font15 pointer whiteColor"
          onClick={() => handleScrollOrNavigate("contact")}
        >
          Contact
        </li>
      </UlStyle>

      <UlStyle className="flexSpaceCenter">
        <li className="semiBold font15 pointer">
          <a
            href="/"
            style={{ padding: "10px 30px 10px 0" }}
            className="whiteColor"
          >
            Log in
          </a>
        </li>
        {/* <li className="semiBold font15 pointer flexCenter">
          <a
            href="/"
            className="radius8 lightBg"
            style={{ padding: "10px 15px" }}
          >
            Get Started
          </a>
        </li> */}
      </UlStyle>
    </Wrapper>
  );
}

const Wrapper = styled.nav`
 width: 400px;
  height: 100vh;
  position: fixed;
  top: 0;
  padding: 0 30px;
  right: ${(props) => (props.sidebarOpen ? "0px" : "-400px")};
  z-index: 9999;
  background-color: #111; /* Optional background */
  overflow-y: auto;
  @media (max-width: 400px) {
    width: 100%;
  }
`;
const SidebarHeader = styled.div`
  padding: 20px 0;
`;
const CloseBtn = styled.button`
  border: 0px;
  outline: none;
  background-color: transparent;
  padding: 10px;
`;
const UlStyle = styled.ul`
  padding: 40px;
  li {
    margin: 20px 0;
  }
`;

const DropdownScrollArea = styled.div`
  max-height: 250px; /* Adjust as needed */
  overflow-y: auto;
  padding-left: 15px;
  margin-bottom: 10px;

  /* Optional Scrollbar Styling */
  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #aaa;
    border-radius: 10px;
  }
`;
